import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationApiClientAccess } from '@nk/access-block';
import { AccountNumberDenomination } from '@nk/company-block';
import { AppFeatureKey, COUNTRY_FEATURES, TransientFileEntity, TransientFileMetaEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

@Injectable()
export class TransientFileService {
  constructor(private _applicationApiAccess: ApplicationApiClientAccess) {}

  public postCompanyAccountCompositeTransientFileMeta(
    companyUuid: string,
    langCode: string,
    fileType: string,
    accountsNumberDenomination: AccountNumberDenomination,
    accountsTypeIdentifier: string,
    accountingYear: number = null,
  ): Observable<TransientFileMetaEntity> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('language_code', String(langCode));
    if (fileType !== 'csv' && fileType !== 'xlsx') {
      console.warn('! Only csv and xlsx is supported, it will default to xlsx now. this is not supported: ' + fileType);
    } else {
      httpParams = httpParams.append('file_type', String(fileType));
    }
    if (accountingYear) {
      httpParams = httpParams.append('accounting_year', String(accountingYear));
    }
    if (accountsTypeIdentifier) {
      httpParams = httpParams.append('accounts_type_identifier', String(accountsTypeIdentifier));
    }
    httpParams = httpParams.append('accounts_number_denomination', String(accountsNumberDenomination));

    return this._applicationApiAccess.get<TransientFileMetaEntity>(
      `/company/${companyUuid}/accounts-data-export/transient-file-meta`,
      { params: httpParams },
      [AppFeatureKey.base, ...COUNTRY_FEATURES],
    );
  }

  public transientFileUrl(transientFileUuid: string): string {
    return `${this._applicationApiAccess.endPointPrefix}/transient-file/${transientFileUuid}`;
  }

  public fetchTransientFile(transientFileUuid: string): Observable<TransientFileEntity> {
    return this._applicationApiAccess.get<TransientFileEntity>(`/transient-file/${transientFileUuid}`);
  }

  public fetchTransientFileMeta(transientFileMeta: string): Observable<TransientFileMetaEntity> {
    return this._applicationApiAccess.get<TransientFileMetaEntity>(`transient-file-meta/${transientFileMeta}`);
  }
}
